export { default } from './LazyDegrees';
